/* `noStyles` can NOT be used on the `Text`s surrounded by this class. If the text is too short, it will appear on the same line as the header text above it, which also has `noStyles`. */
.textAboveLinkButton p {
    margin-bottom: 0px;
}

.riskAndEffectiveness {
    display: flex;
    flex-direction: column;
}

.circleIndicatorAndText {
    display: flex;
    align-items: center;
}

.circleIndicatorAndText svg {
    margin-bottom: 16px;
    margin-right: 4px;
}

.smallSection {
    word-break: break-word;
}

.statusLabel {
    overflow-wrap: break-word;
    width: 75%;
    text-align: center;
}

.dashletsContainer {
    display: flex;
    gap: 48px;
    margin-top: 24px;
}

.dashletColumn {
    flex: 1;
}
